import i18n from "@breward/i18n";

export const LEAGUE_STATES = {
  inactive: {
    label: i18n.t("global:shared.LeagueState.Inactive", "Inactive"),
  },
  active: {
    label: i18n.t("global:shared.LeagueState.Active", "Active"),
  },
  expired: {
    label: i18n.t("global:shared.LeagueState.Expired", "Expired"),
  },
};

export const LEAGUE_TYPES = {
  league: {
    label: i18n.t("global:shared.LeagueType.League", "League"),
  },
  cup: {
    label: i18n.t("global:shared.LeagueType.Cup", "Cup"),
  },
};

export const LEAGUE_POINTS_COUNTING_METHODS = {
  participation: {
    label: i18n.t(
      "global:shared.LeaguePointsCountingMethods.Participation",
      "Participation"
    ),
  },
  placement: {
    label: i18n.t(
      "global:shared.LeaguePointsCountingMethods.Placement",
      "Placement"
    ),
  },
  score: {
    label: i18n.t("global:shared.LeaguePointsCountingMethods.Score", "Score"),
  },
  entries_count: {
    label: i18n.t(
      "global:shared.LeaguePointsCountingMethods.EntriesCount",
      "Entries Count"
    ),
  },
};
